import { render, staticRenderFns } from "./importTel.vue?vue&type=template&id=2c0872dc&scoped=true&"
import script from "./importTel.vue?vue&type=script&lang=js&"
export * from "./importTel.vue?vue&type=script&lang=js&"
import style0 from "./importTel.vue?vue&type=style&index=0&id=2c0872dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0872dc",
  null
  
)

export default component.exports